import React from "react";
import CheckMark from "~/components/Icons/icon-check-mark";
import RedCross from "~/components/Icons/icon-cross";
import IconFile from "~/components/Icons/icon-file";
import s from "./Cells.less";

interface RationaleCellProps {
  rationale?: {
    fileExist?: boolean;
    link?: string;
  } | null;
}

export const RationaleCell: React.FC<RationaleCellProps> = ({ rationale }) => {
  if (!rationale) return <span>-</span>;

  const { fileExist, link } = rationale;

  return (
    <div className={s.rationale}>
      {fileExist ? (
        <>
          <CheckMark fill={"#ec8c22"} />
          {link && (
            <a href={link} download onClick={(e) => e.stopPropagation()}>
              <div className={s.downloadLink}>
                <IconFile />
              </div>
            </a>
          )}
        </>
      ) : (
        <RedCross fill={"#CE282B"} />
      )}
    </div>
  );
};
